module.exports = "<div class=\"modal-body\">\r\n  \r\n    <div class=\"form-group row\">\r\n      <label class=\"col-3 col-form-label\">{{promptLabel}}</label>\r\n      <div class=\"col-9\">\r\n        <input #input class=\"form-control\" [(ngModel)]=\"promptValue\" type=\"text\">\r\n      </div>\r\n    </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-primary\" (click)=\"activeModal.close(promptValue)\">Save</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/prompt/prompt.component.html
// module id = ../../../../../src/app/prompt/prompt.component.html
// module chunks = 1